import React from 'react';
import MuiAlert from '@mui/material/Alert';

const Alert = (props) => {
    const { ...rest } = props;

    return <MuiAlert {...rest} />;
};

export default Alert;
